import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from './SEOHead';
import './NotFound.scss';

const QUICK_LINKS = [
  { label: 'Home', path: '/home' },
  { label: 'Buy', path: '/buy' },
  { label: 'Verify', path: '/verify' },
  { label: 'Stake', path: '/stake' },
  { label: 'Games', path: '/game-info' },
  { label: 'DckSlap', path: '/dckslap' },
  { label: 'Tokenomics', path: '/tokenomics' },
  { label: 'Treasury', path: '/treasury' },
];

const NotFound = () => {
  return (
    <>
      <SEOHead
        title="404 - Page Not Found"
        description="This page does not exist. Return to REDDICKS and navigate tokenomics, buy routes, trust verification, and live utility pages."
        robots="noindex, nofollow"
      />
      <div className="not-found-page">
        <div className="not-found-particles">
          {Array.from({ length: 8 }, (_, i) => (
            <div key={i} className="not-found-particle" />
          ))}
        </div>

        <div className="not-found-content">
          <div className="not-found-code" data-text="404">
            404
          </div>

          <h1 className="not-found-title">Lost in the Memeverse</h1>

          <p className="not-found-description">
            This page has been slapped out of existence. But do not worry, there is still plenty to explore in the REDDICKS ecosystem.
          </p>

          <div className="not-found-actions">
            <Link to="/home" className="not-found-btn primary">
              Back to Home
            </Link>
            <Link to="/dckslap" className="not-found-btn secondary">
              Play DckSlap
            </Link>
          </div>

          <div className="not-found-links">
            <div className="not-found-links-title">Quick Links</div>
            <div className="not-found-links-grid">
              {QUICK_LINKS.map((link) => (
                <Link key={link.path} to={link.path} className="not-found-quick-link">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
